module.exports = __webpack_public_path__ + "img/home-2-636x480.af58d306.jpg";